export const FEEDING_NOT_ANSWERED_LABEL = "Not answered";

/**
 * Normalizes a raw FHIR boolean answer to tri-state form value.
 * Only explicit `true`/`false` are preserved; everything else becomes `undefined`.
 */
export function normalizeNewbornIPPFeedingBoolean(value: unknown): boolean | undefined {
  if (value === true) return true;
  if (value === false) return false;
  return undefined;
}

/**
 * Maps a newborn IPP feeding boolean answer to a display label.
 * @param value - Raw answer value (typically `true`, `false`, or absent).
 * @param unansweredLabel - When provided as the second argument, used for non-boolean values (including `undefined`).
 *   When omitted, defaults to {@link FEEDING_NOT_ANSWERED_LABEL}.
 */
export function formatNewbornIPPFeedingBoolean(
  value: unknown,
  unansweredLabel?: string,
): string | undefined {
  const normalized = normalizeNewbornIPPFeedingBoolean(value);
  if (normalized === true) return "Yes";
  if (normalized === false) return "No";
  if (arguments.length < 2) return FEEDING_NOT_ANSWERED_LABEL;
  return unansweredLabel;
}
